import { RootState } from 'src/types/RootState';

export function getIsRoutingBlocked(state: RootState): boolean {
  return state.modals.length > 0;
}
